import { createApp } from 'vue'
import App from './App.vue'
import 'element-plus/dist/index.css'
import '@/assets/styles/reset.css'
import '@/assets/styles/border.css'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue' // 导入所有图标
import router from '@/router'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import axios from 'axios'

const app = createApp(App)

// 全局注册所有Element Plus图标（解决图标未定义问题）
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局挂载Axios
app.config.globalProperties.$axios = axios

// 挂载路由和Element Plus
app.use(router).use(ElementPlus, { locale: zhCn }).mount('#app')

// 处理ResizeObserver报错（可选）
window.addEventListener('error', function (e) {
  if (e.message.includes('ResizeObserver loop limit exceeded')) {
    e.stopPropagation();
  }
});